'use client';

import { createContext, useContext, useState, useEffect } from 'react';

var GlobalStateContext = createContext({
    globalState: {},
    subscribeField: function () { return function () { return undefined; }; }
});
var useGlobalState = function () { return useContext(GlobalStateContext).globalState; };
function getFieldValue(field, state) {
    var fieldPath = field.split('.');
    var value = state;
    for (var _i = 0, fieldPath_1 = fieldPath; _i < fieldPath_1.length; _i++) {
        var path = fieldPath_1[_i];
        value = value === null || value === void 0 ? void 0 : value[path];
    }
    return value;
}
function useSubscribeField(field) {
    var _a = useContext(GlobalStateContext), globalState = _a.globalState, subscribeField = _a.subscribeField;
    var _b = useState(getFieldValue(field, globalState)), fieldValue = _b[0], setFieldValue = _b[1];
    useEffect(function () {
        var unsubscribe = subscribeField(field, function (props) {
            setFieldValue(props.value);
        });
        return function () {
            unsubscribe();
        };
    }, [field, subscribeField]);
    useEffect(function () {
        setFieldValue(getFieldValue(field, globalState));
    }, [field, globalState]);
    return fieldValue;
}

export { GlobalStateContext, useGlobalState, useSubscribeField };
//# sourceMappingURL=context.js.map
